export const RequestType = {
  OUTGOING: 'outgoing',
  INCOMING: 'incoming',
};
